var map = {
	"./en.png": "c0f9",
	"./en_au.png": "c0c4",
	"./en_ca.png": "a601",
	"./en_id.png": "fadd",
	"./en_mm.png": "d8a4",
	"./en_my.png": "5a75",
	"./en_nz.png": "ecce",
	"./en_sg.png": "a74d",
	"./en_st.png": "f8b3",
	"./en_th.png": "1994",
	"./en_uk.png": "84ce",
	"./en_vn.png": "05e9",
	"./es.png": "e1b2",
	"./flags/ico_australia.png": "55b4",
	"./flags/ico_canada.png": "d6cb",
	"./flags/ico_indonesia.png": "414b",
	"./flags/ico_malaysia.png": "1394",
	"./flags/ico_mexico.png": "980b",
	"./flags/ico_myanmar.png": "53ad",
	"./flags/ico_newzealand.png": "9d1e",
	"./flags/ico_scotland.png": "96f5",
	"./flags/ico_singapore.png": "ab6f",
	"./flags/ico_thailand.png": "2bae",
	"./flags/ico_uk.png": "307b",
	"./flags/ico_usa.png": "f758",
	"./flags/ico_vietnam.png": "acff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "224c";